<template>
  <div>
    <b-modal
      id="detail-announcement-modal"
      size="lg"
      :title="title"
      no-close-on-backdrop
    >
      <table class="table table-bordered table-sm table-striped">
        <tbody>
          <tr>
            <th class="font-weight-bold">Judul</th>
            <td>{{ result.title }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Deskripsi</th>
            <td>{{ result.description }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Gambar</th>
            <td><img :src="imageUrl" alt="" style="max-width: 200px" /></td>
          </tr>
        </tbody>
      </table>

    </b-modal>
  </div>
</template>

<script>
import { BCol, BAvatar, BRow } from "bootstrap-vue";
import BlobImage from "@/components/BlobImage.vue";

export default {
  components: {
    BCol,
    BAvatar,
    BRow,
    BlobImage,
  },
  props: ["pageTitle", "result"],
  data() {
    return {
      title: `Detail ${this.pageTitle}`,
      imageUrl: null,
    };
  },
  watch: {
    result(value) {
      this.$http
        .get(`/employee-activity/announcement?image=${value.image}`, {
          responseType: "blob",
        })
        .then((response) => {
          this.imageUrl = URL.createObjectURL(response.data);
        })
        .catch((error) => {});
    },
  },
  methods: {
    showImage(image) {},
  },
};
</script>
